export { acceptWaitlistSlotMutation } from './acceptWaitlistSlotMutation';
export type {
  AcceptWaitlistSlotPayload,
  AcceptWaitlistSlotResponse,
} from './types';
